/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PreloadImgComponent } from '@t-llevo/common-ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TravelDetailsService } from '../../../services/travel-details.service';
import { TabElementContent } from 'admin-drivers/src/app/common/components/detail-tab-item/models/TabElement';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { Travel } from 'admin-drivers/src/app/common/models/Travel';

@Component({
  selector: 't-llevo-details-personal-section',
  standalone: true,
  imports: [PreloadImgComponent, DetailTabItemComponent],
  template: `
    @if(data && data.driver){
    <div class="row p-3 h-50">
      <t-llevo-detail-tab-item
        class="col-6 h-75"
        contentClasses="h-100 w-100 d-block text-dark"
        rowClasses="py-1"
        [data]="tabItems"
      ></t-llevo-detail-tab-item>
      <div class="col-6 d-flex">
        <commonui-preload-img
          [urlImg]="data.driver.photo"
          [containerClass]="'shadow-sm'"
          imgClass="h-100 w-100"
          [containerHeight]="100"
          [containerWidth]="100"
          unit="%"
          class="h-75 w-75"
        ></commonui-preload-img>
      </div>
    </div>
    }
  `,
})
export class DetailsPersonalSectionComponent {
  protected data: Travel | null = null;
  private destroyRef = inject(DestroyRef);
  protected tabItems: TabElementContent[] = []

  constructor(private travelDetailsSrv: TravelDetailsService) {
    this.travelDetailsSrv.selectedTravel$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        this.data = data;
        this.assignTabItems()
      });
  }

  private assignTabItems() {
    if (this.data && this.data.driver) {
      this.tabItems = [
        {
          name: 'Nombre',
          value: this.data.driver.user.firstname + ' ' + this.data.driver.user.lastname
        },
        {
          name: 'Carnet de identidad',
          value: this.data.driver.ci,
        },
        {
          name: 'Fecha de nacimiento',
          value: new DatePipe('en-US').transform(
            this.data.driver.birthday,
            'dd/MM/yyyy'
          ) as string,
        },
        {
          name: 'Número telefónico',
          value: this.data.driver.user.phone
        },
        {
          name: 'Correo Electrónico',
          value: this.data.driver.user.email,
        },
      ];
    }
  }
}
